import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase, signOut } from '../../lib/supabase';

export default function Settings() {
  const navigate = useNavigate();
  const [settings, setSettings] = useState<Record<string, string>>({});

  useEffect(() => {
    const fetchSettings = async () => {
      const { data } = await supabase
        .from('settings')
        .select('key, value');
      
      if (data) {
        const settingsObj: Record<string, string> = {};
        data.forEach((s) => {
          settingsObj[s.key] = s.value;
        });
        setSettings(settingsObj);
      }
    };
    fetchSettings();
  }, []);

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-white">Configuración</h1>

      <div className="card">
        <h2 className="font-semibold text-[#E5E5EA] mb-3">Cuenta</h2>
        <div className="space-y-2">
          <Link to="/profile" className="block py-2 border-b ">
            <span className="text-white">Editar Perfil</span>
          </Link>
          <button onClick={handleSignOut} className="block w-full text-left py-2 text-red-600 ">
            Cerrar Sesión
          </button>
        </div>
      </div>

      <div className="card">
        <h2 className="font-semibold text-[#E5E5EA] mb-3">Acerca de</h2>
        <div className="space-y-2 text-sm text-[#B3B3B3]">
          <p>Versión de la app: 1.0.0</p>
          <p>Iglesia: {settings.church_name || 'Brisas'}</p>
        </div>
      </div>

      <div className="card">
        <h2 className="font-semibold text-[#E5E5EA] mb-3">Soporte</h2>
        <div className="space-y-2">
          <a href="mailto:soporte@iglesiabrisas.com" className="block py-2 border-b ">
            <span className="text-white">Contactar soporte</span>
          </a>
          <Link to="/terms" className="block py-2 border-b ">
            <span className="text-white">Términos y condiciones</span>
          </Link>
          <Link to="/privacy" className="block py-2 ">
            <span className="text-white">Política de privacidad</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
